import Urls from '@/lib/urls'

export default class Cookies {
  static parse(): Map<string, string> {
    const dict = new Map<string, string>()

    document.cookie.split('; ').forEach(item => {
      const [key, value] = item.split('=')
      dict.set(key, value)
    })

    return dict
  }

  static get(key: string): string | undefined {
    return Cookies.parse().get(key)
  }

  static set(key: string, value: string, expiry_days = 10): void {
    const domain = Urls.domain()
    const expiry = Date.now() + daysToMs(expiry_days)

    const expires = new Date()
    expires.setTime(expiry)

    const cookie = `${key}=${value};expires=${expires.toUTCString()};domain=${domain}`
    document.cookie = cookie
  }
}

function daysToMs(days: number): number {
  return days * 24 * 60 * 60 * 1000
}
